import { isMobile } from '../../utils/environment';

export default isMobile ? 100 : 200;
